import {WixSdk} from 'js-sdk-wrapper';

export function getLocale() {
  const locale = WixSdk.Utils.getLocale();
  if (!/^\w{2}$/.test(locale)) {
    return 'en';
  }
  return locale;
}



// WEBPACK FOOTER //
// ./widget-player/locale.ts